import React, { useState, useRef, useEffect } from "react";
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import "./LearningCalendarContent.css";
import LearningCalendarData from '../LearningCalendar/LearningCalendarData.json';
import LearningCalendarFilters from '../LearningCalendar/LearningCalendarFilters';
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { parse } from 'date-fns';
import AdminPage from "./Admin/AdminPage";
import axios from "axios";
import Alert from '@mui/material/Alert';
import CustomCalendar from "./CustomCalendar";
import { Box } from '@mui/material';
import './CustomCalendar.css';
import { useDispatch, useSelector } from "react-redux";
import { fetchSessions } from "../../Redux/AdminSlice";
import moment from "moment/moment";
import { ResetTvRounded } from "@mui/icons-material";
import { ToastContainer } from "react-toastify";
// import { toast, ToastContainer } from "react-toastify";
const LearningCalendarComponent = (props) => {
    //const [filteredData, setFilteredData] = useState(LearningCalendarData);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const ref = useRef(null);
    const { sessions, error, isLoading } = useSelector((state) => state.admin);
    const [filteredData, setFilteredData] = useState([]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const setDateRange = ([start, end]) => {
        setStartDate(start);
        setEndDate(end);
        handleFilterChange({ startDate: start, endDate: end });
    };
    const [filters, setFilters] = useState({
        capability: '',
        category: '',
        modeDelivery: '',
        targetAudience: '',
        searchTerm: '',
        startDate: null,
        endDate: null
    });
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchSessions());
    }, [dispatch]);

    useEffect(() => {
        if (sessions) {
            setFilteredData(sessions);
        }
    }, [sessions]);

    const handleFilterChange = (newFilters) => {
        const updatedFilters = { ...filters, ...newFilters };
        setFilters(updatedFilters);

        let result = [...sessions];

        const {
            capability,
            category,
            modeDelivery,
            targetAudience,
            searchTerm,
            startDate,
            endDate,
            timezone
        } = updatedFilters;

        if (capability) {
            result = result.filter(t => t.Capability === capability 
                // && moment(t.SessionStartDate).format("YYYY-MM-DD") >= moment().format("YYYY-MM-DD")
            );
        }
        if (category) {
            result = result.filter(t => t.Category === category 
                //  && moment(t.SessionStartDate).format("YYYY-MM-DD") >= moment().format("YYYY-MM-DD")
                );
        }
        if (modeDelivery) {
            result = result.filter(t => t.ModeOfDelivery === modeDelivery
                //  && moment(t.SessionStartDate).format("YYYY-MM-DD") >= moment().format("YYYY-MM-DD")
                );
        }
        if (targetAudience) {
            result = result.filter(t => t.TargetAudienceLevel === targetAudience 
                // && moment(t.SessionStartDate).format("YYYY-MM-DD") >= moment().format("YYYY-MM-DD")
            );
        }
        if (searchTerm) {
            const lower = searchTerm.toLowerCase();
            result = result.filter(t =>
                moment(startDate).format("YYYY-MM-DD") >= moment().format("YYYY-MM-DD") && (
                (t.CourseName && t.CourseName.toLowerCase().includes(lower) ) ||
                (t.Capability && t.Capability.toLowerCase().includes(lower)) ||
                (t.Category && t.Category.toLowerCase().includes(lower)) ||
                (t.ModeOfDelivery && t.ModeOfDelivery.toLowerCase().includes(lower)) ||
                (t.TargetAudienceLevel && t.TargetAudienceLevel.toLowerCase().includes(lower))
                )
            );
        }
        if (startDate) {
            
            const start = moment(startDate).format("YYYY-MM-DD")
            result = result.map(t =>{
                const SelectWeekDate = t.TrainingDayOfEveryWeek ? moment(start).startOf('week').day(t.TrainingDayOfEveryWeek).format("YYYY-MM-DD"):null;
                if(t.TrainingDayOfEveryWeek && SelectWeekDate >= start ){
                    return {  ...t, SessionStartDate: SelectWeekDate}
                }else{
                     return t
                }
                    
            }).filter((item)=>moment(moment(item.SessionStartDate).format("YYYY-MM-DD")).isSameOrBefore(start) && 
                    moment(moment(item.SessionEndDate).format("YYYY-MM-DD")).isSameOrAfter(start)
            )
        }
        if (endDate) {
            const end = moment(endDate).format("YYYY-MM-DD")
            result = result.map(t => {
                 const SelectWeekDate = t.TrainingDayOfEveryWeek ? moment(end).startOf('week').day(t.TrainingDayOfEveryWeek).format("YYYY-MM-DD"):null;

                if(t.TrainingDayOfEveryWeek && SelectWeekDate <= end ){
                    return {  ...t, SessionStartDate: SelectWeekDate}
                }else{
                     return t
                }
            }
                // moment(moment(t.SessionEndDate).format("YYYY-MM-DD")).isSameOrBefore(end) 
            ).filter((item)=>moment(moment(item.SessionEndDate).format("YYYY-MM-DD")).isSameOrAfter(end)
            )
            
        }
        if(timezone){
            result = result.filter(item=>item?.Region?.split(",").some(i=>(i.trim() === timezone[0].Region )) && (moment(item.SessionStartDate).format("YYYY-MM-DD") >= moment().format("YYYY-MM-DD")) || !item.Region  )
             setFilteredData(result);
        }

        setFilteredData(result);
        setCurrentPage(1);
    };

    let paginatedData = filteredData;
    let indexOfFirstItem = 0;
    let indexOfLastItem = filteredData?.length || 0;
    let totalPages = 1;
    if (itemsPerPage !== -1) {
        indexOfLastItem = currentPage * itemsPerPage;
        indexOfFirstItem = indexOfLastItem - itemsPerPage;
        paginatedData = filteredData?.slice(indexOfFirstItem, indexOfLastItem);
        totalPages = Math.ceil(filteredData?.length / itemsPerPage);
    }
    // const formatMonth = (date) =>
    //     new Date(date).toLocaleString('default', { month: 'long' });

    // let monthRange = '';
    
    // if (startDate && endDate) {
    //     const startMonth = formatMonth(startDate);
    //     const endMonth = formatMonth(endDate);

    //     monthRange = startMonth === endMonth
    //         ? startMonth
    //         : `${startMonth} - ${endMonth}`;
    // } else if (startDate) {
    //     monthRange = formatMonth(startDate);
    // } else {
    //     monthRange = new Date().toLocaleString('default', { month: 'long' });
    // }
    const formatMonth = (date) =>
        new Date(date).toLocaleString('default', { month: 'long' });

    let monthRange = '';

    if (paginatedData?.length > 0) {
        const validDates = paginatedData
            .map(item => new Date(item.SessionStartDate))
            .filter(date => !isNaN(date));

        const uniqueMonths = [
            ...new Set(validDates.map(date => formatMonth(date)))
        ];

        if (uniqueMonths.length === 1) {
            monthRange = uniqueMonths[0];
        } else if (uniqueMonths.length > 1) {
            monthRange = `${uniqueMonths[0]} - ${uniqueMonths[uniqueMonths.length - 1]}`;
        } else {
            monthRange = new Date().toLocaleString('default', { month: 'long' });
        }
    } else {
        monthRange = new Date().toLocaleString('default', { month: 'long' });
    }
    return (
        <div className="lc_container">

            <ToastContainer
            className="toastContainerpos"
            position="top-right"
            autoClose={3000}
            closeOnClick
            theme="colored"
            toastClassName="custom-toast"
            bodyClassName="custom-body"
          />
          
            {error && !error.includes("Uploaded Excel has missing Start date or End date at row") && <Alert severity="error" className="errorAlert"><b>Internal Server Error:</b> Please try again with a hard refresh. If the issue persists, contact the Learning Experiences team for further assistance.</Alert>}

            <AdminPage></AdminPage>
            <h2 className="header_lc">List of Trainings in {monthRange}</h2>

            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <LearningCalendarFilters data={filteredData} onFilterChange={handleFilterChange}
                    startDate={startDate}
                    endDate={endDate}
                    setDateRange={setDateRange} />
            </LocalizationProvider>
            <div className="lc_calendar_list">
                {/* Left Side Trainings*/}
                <div className="lc_calendar_scrollable">
                    <div className="lc_filter_list">
                        <div className="lc_page_dropdown">
                            Training list per page
                            <select
                                value={itemsPerPage === -1 ? 'all' : itemsPerPage.toString()}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setItemsPerPage(value === 'all' ? -1 : Number(value));
                                    setCurrentPage(1);
                                }}
                            >
                                {[5, 10, 15, 20].map(n => (
                                    <option key={n} value={n}>{n}</option>
                                ))}
                                <option value="all">All</option>
                            </select>
                        </div>
                    </div>
                    <div className="lc_legend">
                        <div><span className="lc_dot_purple"></span> Today's Trainings</div>
                        <div><span className="lc_dot_yellow"></span> Upcoming Trainings</div>
                    </div>
                   
                    {isLoading ? (
                        <div className="lc_loading">Loading...</div>
                    ) : !error && paginatedData?.length === 0 ? (
                        
                        <div className="lc_no_data">No data found.</div>
                    ) : (
                        paginatedData?.map((training, index) => {
                            
                            const today = filters.startDate ? moment(filters.startDate).format("YYYY-MM-DD"):moment().format("YYYY-MM-DD");
                            const startDate = moment.utc(training.SessionStartDate).local().format("YYYY-MM-DD")
                            const endDate = moment.utc(training.SessionEndDate).local().format("YYYY-MM-DD")
                            
                            let trainingStart = new Date(training.SessionStartDate);
                            
                            let borderClass = "";
                            let TrainingDate 
                            let TrainingDay
                            
                            if(training.TrainingDayOfEveryWeek && training.TrainingDayOfEveryWeek.length){
                               
                                let SessionDate = moment(today).startOf('week').day(training?.TrainingDayOfEveryWeek).format("YYYY-MM-DD");
                                 let NextSessionDate = moment(SessionDate).startOf('week').day(training?.TrainingDayOfEveryWeek).format("YYYY-MM-DD");
                               
                                 if(moment(NextSessionDate).isBefore(today)){
                                    return null
                                 }
                                else{
                                     borderClass = "lc_upcoming"
                                     TrainingDate = moment(training.SessionStartDate).format("DD MMM")
                                     TrainingDay = moment(training.SessionStartDate).format("DD MMM YYYY")
                                    }
                                 
                                if(moment(SessionDate).isSameOrAfter(moment().format("YYYY-MM-DD")) ){
                                    borderClass = "lc_upcoming"
                                     TrainingDate = moment(SessionDate).format("DD MMM")
                                     TrainingDay = moment(SessionDate).format("DD MMM YYYY")
                                }
                            }else if (startDate === today) {
                                borderClass = "lc_today";
                               TrainingDate = moment(trainingStart).format("DD MMM")
                            } else if (moment(training.SessionStartDate).format("YYYY-MM-DD") > moment().format("YYYY-MM-DD")) {
                                borderClass = "lc_upcoming";
                                TrainingDate = moment(trainingStart).format("DD MMM")
                            } else if (moment(training.SessionStartDate).format("YYYY-MM-DD") == moment().format("YYYY-MM-DD")) {
                                borderClass = "lc_today";
                                 TrainingDate = moment(trainingStart).format("DD MMM")
                            }
                            else{
                                 TrainingDate = moment(trainingStart).format("DD MMM")
                            }

                            return (
                                <div className={`lc_calendar_text ${borderClass}`} key={index}>
                                    {/* Date section */}
                                    <div className="lc_date_sec">
                                        {/* {trainingStart.toLocaleDateString('en-GB', {
                                            day: '2-digit',
                                            month: 'short'
                                        }) */}
                                         {TrainingDate}
                                        {/* } */}
                                       
                                    </div>

                                    <div className="lc_dotted_divider"></div>

                                    {/* Details Section */}
                                    <div className="lc_details_sec">
                                        <div>
                                            <span>
                                                <img src={process.env.PUBLIC_URL + "/images/LearningCalendar/target_audience.png"} alt="target" /> {training.TargetAudienceLevel}
                                            </span>
                                            <span>
                                                {training?.ModeOfDelivery ?<img src={process.env.PUBLIC_URL + "/images/LearningCalendar/mode.png"} alt="mode" />:null} 
                                                {training.ModeOfDelivery}
                                            </span>
                                             <span>
                                                <img src={process.env.PUBLIC_URL + "/images/LearningCalendar/region.png"} alt="mode" />
                                                {training.Region?training.Region :"All region"}
                                            </span>
                                        </div>

                                        <h2>{training.CourseName}</h2>
                                        {training?.Description?<p style={{fontSize:"0.8em",paddingBottom:'10px',fontWeight:'550'}}>{training.Description}</p>:null}

                                        <div>
                                            {!training.TrainingDayOfEveryWeek ?
                                            <span>
                                               
                                                <img src={process.env.PUBLIC_URL + "/images/LearningCalendar/calendar.png"} alt="calendar" />
                                                {new Date(training.SessionStartDate).toLocaleDateString('en-GB', {
                                                    day: '2-digit',
                                                    month: 'short',
                                                    year: 'numeric'
                                                })} to {new Date(training.SessionEndDate).toLocaleDateString('en-GB', {
                                                    day: '2-digit',
                                                    month: 'short',
                                                    year: 'numeric'
                                                })}
                                            </span>:
                                            <span>
                                               
                                                <img src={process.env.PUBLIC_URL + "/images/LearningCalendar/calendar.png"} alt="calendar" />
                                                {new Date(TrainingDay).toLocaleDateString('en-GB', {
                                                    day: '2-digit',
                                                    month: 'short',
                                                    year: 'numeric'
                                                })} to {new Date(TrainingDay).toLocaleDateString('en-GB', {
                                                    day: '2-digit',
                                                    month: 'short',
                                                    year: 'numeric'
                                                })}
                                            </span>}
                                            <span>
                                                <img src={process.env.PUBLIC_URL + "/images/LearningCalendar/duration.png"} alt="duration" /> {training.Duration} hours
                                            </span>
                                            {/* <span>{training.Capability}</span> */}
                                            <span>{training.Category}</span>
                                        </div>
                                        
                                    </div>

                                    <div className="lc_dotted_divider-short"></div>

                                    {/* Register Button */}
                                    <div>
                                        <a href={training.WorkdaySessionLink} target="_blank" rel="noopener noreferrer">
                                            <button className="lc_register_sec">Register Now</button>
                                        </a>
                                    </div>
                                </div>
                            );
                        })
                    )}
                </div>

                {/* Right Side Calendar */}
                <Box
                    className="lc_calendar_right"
                >
                    {/* <Calendar /> */}
                    <CustomCalendar
                        startDate={startDate}
                        endDate={endDate}
                        setDateRange={setDateRange}
                    />
                </Box>
                    
                {/* Pagination */}
                <div className="lc_pagination_controls">
                    <div className="lc_page_nav">
                        <img
                            src={process.env.PUBLIC_URL + "/images/LearningCalendar/left-arrow.png"}
                            alt="Previous"
                            onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
                            className={`lc_arrow ${currentPage === 1 ? 'disabled' : ''}`}
                        />

                        <span className="lc_page_range">
                            {itemsPerPage === -1
                                ? `1 - ${filteredData?.length}`
                                : `${indexOfFirstItem + 1} - ${Math.min(indexOfLastItem, filteredData?.length)}`}
                        </span>
                        <span className="lc_page_total">of {filteredData?.length}</span>

                        <img
                            src={process.env.PUBLIC_URL + "/images/LearningCalendar/right-arrow.png"}
                            alt="Next"
                            onClick={() => currentPage < totalPages && setCurrentPage(currentPage + 1)}
                            className={`lc_arrow ${currentPage === totalPages ? 'disabled' : ''}`}
                        />
                    </div>

                    <div className="lc_page_dropdown">
                        Training list per page
                        <select
                            value={itemsPerPage === -1 ? 'all' : itemsPerPage.toString()}
                            onChange={(e) => {
                                const value = e.target.value;
                                setItemsPerPage(value === 'all' ? -1 : Number(value));
                                setCurrentPage(1);
                            }}
                        >
                            {[5, 10, 15, 20].map(n => (
                                <option key={n} value={n}>{n}</option>
                            ))}
                            <option value="all">All</option>
                        </select>

                    </div>
                   
                </div>
                 </div><p style={{fontSize:'0.8em'}}> If you have any additional training requirement;
                        please raise a request via this form:<a style={{color:'#7500C0'}} href="https://apps.powerapps.com/play/e/default-e0793d39-0939-496d-b129-198edd916feb/a/a717c9aa-f39d-4070-bdb5-e1e3d6fd50b4?tenantId=e0793d39-0939-496d-b129-198edd916feb&sourcetime=1732794644453&source=portal"> ATCGN Training Request Form - Power Apps</a></p>
           
        </div>
    );
};

export default LearningCalendarComponent;
